module.exports = __webpack_public_path__ + "img/dashboard.d113c94e.svg";